import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import _ from 'lodash';

import { Button, LinearProgress as LoadingOverlay } from '@material-ui/core';
import {
  DataGridPro, useGridApiRef, GridFooter, frFR, enUS,
  GridToolbarContainer, GridToolbarFilterButton, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';

import Print from './Print';
import Export from './Export';
import Create from './Create';
import Update from './Update';

import { get, remove, update } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';

import { useAdminContext } from '../../../../Context/Admin/Provider';
import { colors, roles, useStateWithCallback, toastTimerValue } from '../../../../Shared/utils';
import { changeAdminColumns, changeSettings, translatedGridFilters } from '../../../../Functions/utils';

import { updateGroupColumnsOrder, updateSavedGroups } from '../../../../Functions/user';
import { decodeHTMLEntities } from '../../../../Functions/utils';

import { getGroups } from '../../../../Functions/reporting';

import '../Admin.css';
import '../../../SweetAlert.css'

export default function GroupsList() {
  const { t } = useTranslation();
  const apiRef = useGridApiRef();

  const [{ settings, user }, appDispatch] = useAppContext();
  const [{ groupsLocationsStatus }, eventDispatch] = useEventContext();
  // const [{ groupColumns }, dispatch] = useAdminContext();

  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [model, setModel] = useStateWithCallback({filtered: null, selected: []});
  
  const [highlightedRow, setHighlightedRow] = useState(null);

  const [reordering, setReordering] = useState(null);
  const [reorderedColumn, setReorderedColumn] = useState("");

  const [oldIndex, setOldIndex] = useState(null);
  const [targetIndex, setTargetIndex] = useState(null);

  const [loadedColumnsFromDatabase, setLoadedColumnsFromDatabase] = useState(false);
  const [groupColumnsFromDatabase, setGroupColumnsFromDatabase] = useState({});


  useEffect(() => {
    if (!loadedColumnsFromDatabase) {
      setLoadedColumnsFromDatabase(true);

      const groupColumnsOrder = user.groupColumnsOrder ? JSON.parse(user.groupColumnsOrder) : {};

      const allGroupColumns = {
        id: { hide: true, order: 1, width: 100 },
        favorite: { hide: false, order: 2, width: 50 },
        name: { hide: false, order: 3, width: 600 },
        management: { hide: false, order: 4, width: 475 },
        owner: { hide: false, order: 5, width: 350 },
        sql_id: { hide: false, order: 6, width: 200 },
        locations: { hide: false, order: 7, width: 450 },
        users: { hide: false, order: 8, width: 450 },
        actions: { hide: false, order: 9, width: 100 }
  }
  
      for (const key of Object.keys(allGroupColumns)) {
        if (groupColumnsOrder[key]) {
          allGroupColumns[key] = groupColumnsOrder[key];
        }
      }
      // console.log("173 - allGroupColumns=", allGroupColumns);

      const orderedKeys = Object.keys(allGroupColumns)
        .sort((a, b) => {
          return allGroupColumns[a].order > allGroupColumns[b].order ? 1 : -1;
        });
      // console.log("173 - orderedKeys=", orderedKeys);

      let i = 1;
      for (const key of orderedKeys) {
        allGroupColumns[key].order = i;
        i++;
      }
      // console.log("113 - allGroupColumns=", allGroupColumns);
      setGroupColumnsFromDatabase(allGroupColumns);
    }
  }, [loadedColumnsFromDatabase]);


  useEffect(() => {
    apiRef.current.subscribeEvent('columnHeaderDragStart', (params) => {
      setReordering(true);
      setReorderedColumn("");
      setOldIndex(null);
      setTargetIndex(null);
    });

    apiRef.current.subscribeEvent('columnHeaderDragEnd', (params) => {
      setReordering(false);
    });
  }, [apiRef]);


  useEffect(() => {
    if (reordering === false) {
      changeColumnsOrder(reorderedColumn, oldIndex, targetIndex);
      setReordering(null);
    }
  }, [reordering]);


  let columns = [];

  if (groupColumnsFromDatabase.id) {
    columns = [ // default visible width: 1500  
    {
      field: 'id',
      headerName: 'ID',
      hide: groupColumnsFromDatabase.id.hide,
      width: groupColumnsFromDatabase.id.width
    },
    {
        // sortable: false,
      field: 'favorite',
      // type: 'activeFilter',
      hide: groupColumnsFromDatabase.favorite.hide,
      width: groupColumnsFromDatabase.favorite.width,
      headerName: t('admin.groups.columns.favorite'),
      valueGetter: (params) => {
        return params.row.favoriteId !== null;
      },

      renderCell: ({ row }) => {
        return (
          <div>
            <Button
              className="button icon"
              title={t('global.favorite')}
              onClick={(e) => {
                e.stopPropagation();
                handleUpdateFavorite(e, row.id)
              }}
            >
              <span
                className={"material-icons"}
                style={{
                  textAlign: 'left',
                  fontSize: '20px',
                  padding: '0 0px',
                  color: row.favoriteId ? 'rgb(var(--favorite-color))' : 'rgb(var(--nofavorite-color))'
                }}
              >
                {row.favoriteId ? 'star' : 'star_border'}
              </span>
            </Button>
          </div>
        )
      }
    },
    {
      field: 'name',
      headerName: t('admin.groups.columns.name'),
      hide: groupColumnsFromDatabase.name.hide,
      width: groupColumnsFromDatabase.name.width
    },
    {
      field: 'management',
      type: 'singleSelect',
      valueOptions: [
       'France',
       'US'
      ],
      headerName: t('admin.groups.columns.management'),
      hide: groupColumnsFromDatabase.management.hide,
      width: groupColumnsFromDatabase.management.width
    },
    {
      field: 'owner',
      hide: groupColumnsFromDatabase.owner.hide,
      width: groupColumnsFromDatabase.owner.width,
      headerName: t('admin.groups.columns.creator'),
      valueGetter: (params) => {
        return params.row.email;
      }
    },
      {
        field: 'sql_id',
        hide: groupColumnsFromDatabase.sql_id ? groupColumnsFromDatabase.sql_id.hide : false,
        width: groupColumnsFromDatabase.sql_id ? groupColumnsFromDatabase.sql_id.width : 350,
        headerName: t('admin.groups.columns.sql_id'),
        valueGetter: (params) => {
          return params.row.sQL_ID;
        }
      },
      {
        field: 'locations',
        hide: groupColumnsFromDatabase.locations ? groupColumnsFromDatabase.locations.hide : false,
        width: groupColumnsFromDatabase.locations ? groupColumnsFromDatabase.locations.width : 350,
        headerName: t('admin.groups.columns.locations'),
        valueGetter: (params) => {
          return params.row.locations;
        }
      },
      {
        field: 'users',
        hide: groupColumnsFromDatabase.users ? groupColumnsFromDatabase.users.hide : false,
        width: groupColumnsFromDatabase.users ? groupColumnsFromDatabase.users.width : 350,
        headerName: t('admin.groups.columns.users'),
        valueGetter: (params) => {
          return params.row.users;
        }
      },
    /*{ field: 'wipeReport', headerName: t('admin.groups.columns.wipe_report'), hide: groupColumns.wipeReport.hide, width: groupColumns.wipeReport.width },
    { field: 'pageSize', headerName: t('admin.groups.columns.page_size'), hide: groupColumns.pageSize.hide, width: groupColumns.pageSize.width },*/
    {
      field: 'actions',
      headerName: 'Actions',
      hide: groupColumnsFromDatabase.actions.hide,
      width: groupColumnsFromDatabase.actions.width,
      
      sortable: false,
      filterable: false,

      align: 'right',
      headerAlign: 'right',

      renderCell: ({ row }) => {
        let forceDisabled = false;
        if (row.owner !== null && user.roleId >= roles.stAdmin) {
          forceDisabled = true;
          if (row.owner === user.id)
            forceDisabled = false;
        }

        return (
        <div>
          <Button
              disabled={loading || forceDisabled}
            title={t('global.update')}
            style={{minWidth: 'unset'}}
            onClick={() => setSelectedGroup(row)}
          >
            <span className="material-icons-outlined" style={{color: '#222'}}>edit</span>
          </Button>
          <Button
              disabled={loading || forceDisabled}
            title={t('global.delete')}
            style={{minWidth: 'unset'}}
            onClick={() => handleDelete(row)}
          >
            <span className="material-icons-outlined" style={{color: '#f22'}}>delete</span>
          </Button>
        </div>
      )
    }
    }
  ] // Keep columns order between sessions
    .sort((a, b) => groupColumnsFromDatabase[a.field].order - groupColumnsFromDatabase[b.field].order);
  }

  const handleUpdateFavorite = (e, group) => {
    e.preventDefault();

    const favorite = { groupId: group };
    let tmpArray = new Array();
    for (const grp of groups) {
      const tmpGrp = {
        ...grp
      }
      if (grp.id == group) {
        if (grp.favoriteId)
          tmpGrp.favoriteId = null;
        else
          tmpGrp.favoriteId = 'fake';
      }
      tmpArray.push(tmpGrp);
    }
    setGroups(tmpArray);

    try {
      update({ type: 'favorite', favorite }).then(res => {
        appDispatch({ forceReload: true, forceReloadScenario: true });
        eventDispatch({ groupsLocationsStatus: 'pending' });

      });
    }
    catch (error) {
      console.log("681 - error=", error);
    }
  };

  const handleDelete = (group) => {
    // console.log("218 - group=", group);
    // const input = window.prompt(t('admin.groups.delete.confirm'));
    // const input = window.prompt(t('admin.groups.delete.confirm', { name: group.name }))

    const newText = group.name.replace(/ /g, ' ');

    if (group.locations_count > 0) {

      const htmlText = group.locations_count === 1 ? t('admin.groups.delete.existing_location') : t('admin.groups.delete.existing_locations', { locations_count: group.locations_count });
      Swal.fire({
        allowOutsideClick: false,
        title: t('global.dialog_title'),
        html: htmlText,
        // input: "text",
        showCancelButton: false,
        confirmButtonText: t("global.ok"),
        customClass: {
          confirmButton: 'confirm-button-class',
          title: 'title-class',
          icon: 'icon-class'
        }
      }).then((value) => {
        return;
      })
    }
    else {
    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('admin.groups.delete.confirm', { name: newText }),
      input: "text",
      showCancelButton: true,
      confirmButtonText: t("global.ok"),
      cancelButtonText: t("global.cancel"),
      inputValidator: (value) => {
        const newValue = value.replace(/ /g, ' ');
          const newName = group.name.replace(/ /g, ' ');

          // console.log("507 - value=", value, newValue, group.name, newValue === group.name);
          if (newValue != newName && value != group.name && newValue != group.name) {   // CHECK loc.label === value
          return t('admin.groups.delete.validation');
        }
        return "";
      },
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then((value) => {
      // console.log("316 - value=", value);

      if (value && value.isConfirmed) {
        const newValue = value && value.value.replace(/ /g, ' ');
          const newName = group && group.name && group.name.replace(/ /g, ' ');

        // console.log("507 - value=", value, newValue, loc.label, newValue === loc.label);
          if (newValue === newName || value === group.name || newValue === group.name) {   // CHECK loc.label === value

      setLoading(true);

      remove({type: 'group', id: group.id}).then(res => {
        setLoading(false);
            if (!res.success) {
              return toast(decodeHTMLEntities(t('admin.groups.errors.' + res, { name: group.name })), { type: 'error' });
            }

        setGroups(groups.filter(row => row.id !== group.id));
            toast(decodeHTMLEntities(t('admin.groups.delete.success', { name: group.name })), { type: 'success' });

            const savedGroups = JSON.parse(user.savedGroups);
            const newSavedGroups = savedGroups.filter(grp => grp !== group.id);
            const savedGroupsChanged = !_.isEqual(savedGroups, newSavedGroups);

            if (savedGroupsChanged) {
              updateSavedGroups(JSON.stringify(newSavedGroups));

              if (settings.mode === 'modules')
                eventDispatch({ groupsLocationsStatus: 'force', deploymentsStatus: 'pending' });
              else {
                eventDispatch({ groupsLocationsStatus: 'force', scenariosStatus: 'pending' });
              }
            }
            else {
              eventDispatch({ groupsLocationsStatus: 'force' });
            }
      });
    }
      }
    });
    }
  };


  const changeColumnsWidth = (col) => {
    const prev = JSON.stringify(groupColumnsFromDatabase);
    let newGroupColumns = groupColumnsFromDatabase;
    newGroupColumns[col.colDef.field].width = col.width;
    const next = JSON.stringify(newGroupColumns);

    if (prev !== next) {
      updateGroupColumnsOrder(newGroupColumns);
      setGroupColumnsFromDatabase(newGroupColumns);

      const newUser = {
        ...user,
        groupColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }
  }


  const changeColumnsVisibility = (col) => {
    const prev = JSON.stringify(groupColumnsFromDatabase);
    let newGroupColumns = groupColumnsFromDatabase;
    newGroupColumns[col.colDef.field].hide = !col.isVisible;
    const next = JSON.stringify(newGroupColumns);

    if (prev !== next) {
      updateGroupColumnsOrder(newGroupColumns);
      setGroupColumnsFromDatabase(newGroupColumns);

      const newUser = {
        ...user,
        groupColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }
  }



  const changeColumnsOrder = (reorderedColumn, oldIndex, targetIndex) => {

    const prev = JSON.stringify(groupColumnsFromDatabase);

    let ecart = targetIndex - oldIndex;
    if (ecart > 0)
      ecart = ecart + 0.5;
    else
      ecart = ecart - 0.5;

    let newGroupColumns = {};
    for (const columnName in groupColumnsFromDatabase) {
      const column = groupColumnsFromDatabase[columnName];

      newGroupColumns[columnName] = groupColumnsFromDatabase[columnName];

      if (columnName === reorderedColumn)
        newGroupColumns[columnName].order = newGroupColumns[columnName].order + ecart;
        }

    const orderedKeys = Object.keys(newGroupColumns)
      .sort((a, b) => {
        return newGroupColumns[a].order > newGroupColumns[b].order ? 1 : -1;
      });

    let i = 1;
    for (const key of orderedKeys) {
      newGroupColumns[key].order = i;
      i++;
    }
    const next = JSON.stringify(newGroupColumns);

    if (prev !== next) {
      updateGroupColumnsOrder(newGroupColumns);
      setGroupColumnsFromDatabase(newGroupColumns);

      const newUser = {
        ...user,
        groupColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }

    setReordering(null);
    setReorderedColumn("");
    setOldIndex(null);
    setTargetIndex(null);
  }

  // const changeColumnsOrder = (col) => {
  //   const prev = JSON.stringify(groupColumnsFromDatabase);

  //   let newGroupColumns = {}; // accountColumnsFromDatabase;

  //   for (const columnName in groupColumnsFromDatabase) {
  //     const column = groupColumnsFromDatabase[columnName];

  //     newGroupColumns[columnName] = groupColumnsFromDatabase[columnName];

  //     if (column.order - 1 === col.oldIndex) {
  //       newGroupColumns[columnName].order = col.targetIndex + 1;
  //     }
  //     else {
  //       if (column.order - 1 > col.oldIndex) {
  //         newGroupColumns[columnName].order = newGroupColumns[columnName].order - 1;
  //       }

  //       if (column.order - 1 >= col.targetIndex) {
  //         newGroupColumns[columnName].order = newGroupColumns[columnName].order + 1;
  //       }
  //     }
  //   }
  //   const next = JSON.stringify(newGroupColumns);

  //   if (prev !== next) {
  //     updateGroupColumnsOrder(newGroupColumns);
  //     setGroupColumnsFromDatabase(newGroupColumns);

  //     const newUser = {
  //       ...user,
  //       groupColumnsOrder: next
  //     }
  //     appDispatch({ user: newUser });
  //   }
  // }

  const selectedOption = () => {
    if (!selectedGroup) return null;

    // determine if user wants to create or edit a group
    return selectedGroup.id ? (
      <Update groups={groups} setGroups={setGroups} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup}/>
    ) : (
      <Create groups={groups} setGroups={setGroups} setSelectedGroup={setSelectedGroup}/>
    );
  };

  const rowsToPrint = () => {
    const filtered = model.filtered ?? groups;

    // .slice() creates a new array
    const rows = filtered.slice().filter(group => (
      model.selected.length > 0 ? model.selected.includes(group.id) : group.id > 0
    ));

    return rows;
  };

  const updateRowsAndPrint = () => {
    setModel(
      {...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values())},
      () => window.print()
    );
  };


  useEffect(() => {
    // console.log("386 - useEffect... groups");

    document.title = t('admin.groups.page');
    if (groups.length === 0) get({type: 'group'}).then(res => {
      setLoading(false);

      if (!res.success) {       
        return toast(decodeHTMLEntities(t('admin.groups.errors.' + res)), { type: 'error' });
      }

      for (const group of res.groups) {
        if (group.locations && group.locations.slice(-2) === ", ") {
          group.locations = group.locations.slice(0, -2);
        }
      }
      for (const group of res.groups) {
        if (group.users && group.users.slice(-2) === ", ") {
          group.users = group.users.slice(0, -2);
        }
      }
      console.log("559 - res.groups=", res.groups);
      setGroups(res.groups);
    });
  }, [t, groups]);


  // console.log("270 - groupColumnsFromDatabase=", groupColumnsFromDatabase);
  // console.log("552 - groupColumnsFromDatabase=", groupColumnsFromDatabase);
  // console.log("553 - columns=", columns);
  // console.log("956 - groups=", groups);

  return (
    <div className="admin groups">
      <DataGridPro
        apiRef={apiRef}
        loading={loading}
        // checkboxSelection
        disableSelectionOnClick
        
        pageSize={settings.pageSize}
        rows={groups}
        columns={columns}
        pagination={settings.pagination}

        onSelectionModelChange={selected => setModel({ ...model, selected })}
        onPageSizeChange={pageSize => changeSettings(t, 'pageSize', pageSize, settings, appDispatch)}

        getRowClassName={(params) => {
          return params.id === highlightedRow ? "highlight" : "";
        }}
        onRowClick={o => {
          if (o.id === highlightedRow)
            setHighlightedRow(null);
          else
            setHighlightedRow(o.id)
        }}

        onRowDoubleClick={o => {
          const g = groups.find((groupElement) => {
            return groupElement.id === o.id;
          });

          if (g) {
            let forceDisabled = false;
            if (g.owner !== null && user.roleId >= roles.stAdmin) {
              forceDisabled = true;
              if (g.owner === user.id)
                forceDisabled = false;
            }

            if (!forceDisabled)
              setSelectedGroup(g);
          }
        }}

        // onColumnWidthChange={col => changeAdminColumns({
        //   column: col.colDef.field, columns: groupColumns, dispatch,
        //   view: 'group', type: 'width', value: col.width
        // })} // Save custom column width set by the user
        // onColumnVisibilityChange={col => changeAdminColumns({
        //   column: col.field, columns: groupColumns, dispatch,
        //   view: 'group', type: 'hide', value: !col.isVisible
        // })} // Save hidden column state set by the user
        // onColumnOrderChange={col => changeAdminColumns({
        //   column: col.field, columns: groupColumns, dispatch,
        //   view: 'group', type: 'order', value: { old: col.oldIndex, new: col.targetIndex }
        // })} // Save custom column order set by the user

        onColumnWidthChange={(params, event) => {
          changeColumnsWidth(params);
        }}

        onColumnVisibilityChange={(params, event) => {
          changeColumnsVisibility(params);
        }}

        onColumnOrderChange={(params, event) => {
          //changeColumnsOrder(params);
          if (oldIndex === null) {
            setReorderedColumn(params.field)
            setOldIndex(params.oldIndex);
          }
          setTargetIndex(params.targetIndex);
        }}

        localeText={{
          ...(localStorage.getItem('lang') === 'fr' ? frFR : enUS).props.MuiDataGrid.localeText,
          ...translatedGridFilters(t)
        }}

        components={{
          // ColumnSortedAscendingIcon: () => (
          //   <div
          //     class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
          //     style={{ color: colors.softthinks }}
          //   >
          //     arrow_upward
          //   </div>
          // ),
          ColumnSortedAscendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_upward
            </div>
          ),
          ColumnSortedDescendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_downward
            </div>
          ),
          ColumnUnsortedIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks, opacity: '0.4' }}
            >
              remove
            </div>
          ),
          LoadingOverlay,
          Toolbar: () => (
            <div className="content__header">
              <h2>{t('admin.groups.title')}{'\u2000\u2013\u2000'}
                <span style={{color: colors.softthinks}}>
                  {loading ? (t('global.loading') + '...') : apiRef.current.getVisibleRowModels().size}
                </span>
              </h2>

              <div className="options">
                <GridToolbarContainer>
                  <GridToolbarFilterButton/>
                  <GridToolbarColumnsButton/>
                </GridToolbarContainer>
                <span className="separation"/>

                <div className="actions">
                  <Export apiRef={apiRef} loading={loading} model={model} setModel={setModel}/> {/* Excel / PDF Download */}
                  <button title={t('global.actions.print')} className="button icon" onClick={updateRowsAndPrint} disabled={loading}>
                    <span className="material-icons-round">print</span> {/* Print */}
                  </button>
                </div>
                <span className="separation"/>

                <Button
                  className="button"
                  onClick={() => setSelectedGroup({})}
                  startIcon={<span className="material-icons-round">add_circle_outline</span>}
                >{t('admin.groups.create.button')}</Button>
              </div>
            </div>
          ),

          Footer: () => (
            <div className="datagrid__footer">
              <GridFooter/>
              <div className="checkbox">
                <input
                  id="pagination"
                  type="checkbox"
                  defaultChecked={settings.pagination}
                  onChange={() => changeSettings(t, 'pagination', !settings.pagination, settings, appDispatch)}
                />
                <label htmlFor="pagination">PAGINATION</label>
              </div>
            </div>
          )
        }}
      />

      {selectedOption()}

      {(groups.length > 0) && <Print groups={rowsToPrint()}/>}
    </div>
  );
}
